<template>
  <div class="goods-editor">
    <FormList
      :list="formList"
      :data="formData"
      :onChange="onInputChange"
    />
    <ButtonRow
      firstText="删 除"
      :firstClick="deleteReceiver"
      :secondClick="saveReceiver"
      :bottom="true"
    />
  </div>
</template>

<script>
import {
  Button,
  Row,
  Notify
} from 'vant'
import FormList from '@components/FormList'
import { invoiceRequest } from '@services'
import { isEmail } from '@utils/basicUtil'
import ButtonRow from '@components/ButtonRow'

export default {
  data () {
    return {
      formData: {},
      formList: [
        {
          type: 'text',
          field: 'userName',
          label: '收件人',
          required: true,
          placeholder: '输入客户联系人姓名'
        },
        {
          type: 'text',
          field: 'address',
          required: true,
          label: '收件地址',
          placeholder: '输入客户收件地址'
        },
        {
          type: 'text',
          field: 'telephone',
          required: true,
          label: '电话',
          placeholder: '输入客户联系电话'
        },
        {
          type: 'text',
          field: 'email',
          required: true,
          label: '邮箱',
          placeholder: '请输入电票收件邮箱'
        },
        {
          type: 'switch',
          field: 'defaultFlag',
          label: '设为默认'
        }
      ]
    }
  },
  mounted () {
    this.getReceiverInfo()
  },
  methods: {
    onInputChange ({ e, field }) {
      this.formData[field] = e
    },
    delete () {
      this.deleteReceiver()
    },
    saveReceiver () {
      if (!isEmail(this.formData.email)) {
        return Notify({ type: 'danger', message: '邮箱格式不正确' })
      }
      if (this.formData.telephone.trim().length === 0) {
        return Notify({ type: 'danger', message: '联系电话不能为空' })
      }
      if (this.formData.userName.trim().length === 0) {
        return Notify({ type: 'danger', message: '联系人不能为空' })
      }
      if (this.formData.address.trim().length === 0) {
        return Notify({ type: 'danger', message: '收件地址不能为空' })
      }
      this.saveReceiverInfo()
    },
    async getReceiverInfo () {
      const postData = {
        id: this.$route.query.receiverId
      }
      const data = await invoiceRequest.customer.getReceiverInfo(postData)
      if (data.success) {
        const {
          userName,
          address,
          telephone,
          email,
          defaultFlag
        } = data.result
        this.formData = {
          userName,
          address,
          telephone,
          email,
          defaultFlag: defaultFlag === 0
        }
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    async saveReceiverInfo (params) {
      const postData = {
        id: this.$route.query.receiverId,
        merchantId: this.$route.query.merchantId,
        ...params,
        ...this.formData,
        defaultFlag: this.formData.defaultFlag ? 0 : 1
      }
      const data = await invoiceRequest.customer.editReceiver(postData)
      if (data.success) {
        Notify({ type: 'success', message: '编辑收件地址信息成功' })
        this.$router.go(-1)
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    async deleteReceiver () {
      const postData = {
        id: this.$route.query.receiverId
      }
      const data = await invoiceRequest.customer.deleteReceiver(postData)
      if (data.success) {
        Notify({ type: 'success', message: '删除收件地址信息成功' })
        this.$router.go(-1)
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    }
  },
  components: {
    FormList,
    ButtonRow,
    [Button.name]: Button,
    [Row.name]: Row
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
